/**
 * Títulos disponíveis na aplicação.
 */
export enum PageTitles {
  COVERAGE = 'Seguro Celular',
  MANUAL = 'Manual do produto',
  TERMS = 'Termos e condições',
}
